import { useEffect, useMemo, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function AccountSettings() {
  const token = localStorage.getItem("token")?.trim();

  const authHeaders = useMemo(
    () => ({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
    [token]
  );

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [message, setMessage] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const res = await axios.get(`${API_URL}/auth/me`, authHeaders);

        setName(res.data.name || "");
        setEmail(res.data.email || "");
      } catch (error) {
        setMessage(
          error.response?.data?.message || "Could not load account details."
        );
      }
    };

    if (token) {
      loadProfile();
    }
  }, [token, authHeaders]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsSaving(true);
      setMessage("");

      const res = await axios.patch(
        `${API_URL}/auth/me`,
        {
          name,
          email,
          currentPassword,
          newPassword,
        },
        authHeaders
      );

      localStorage.setItem("token", res.data.token);

      setCurrentPassword("");
      setNewPassword("");
      setMessage("Account updated successfully.");
    } catch (error) {
      setMessage(error.response?.data?.message || "Could not update account.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={styles.page}>
      <form onSubmit={handleSubmit} style={styles.card}>
        <h1>Account Settings</h1>
        <p style={styles.subtitle}>
          Update your name, email, or password.
        </p>

        {message && <p style={styles.message}>{message}</p>}

        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Full name"
          style={styles.input}
          required
        />

        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email address"
          style={styles.input}
          required
        />

        <hr style={styles.divider} />

        <p style={styles.note}>
          Leave password fields empty if you do not want to change password.
        </p>

        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          placeholder="Current password"
          style={styles.input}
        />

        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="New password"
          style={styles.input}
        />

        <button type="submit" disabled={isSaving} style={styles.button}>
          {isSaving ? "Saving..." : "Save Changes"}
        </button>
      </form>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    padding: "24px",
    background: "#f4f6f8",
    fontFamily: "Arial, sans-serif",
  },

  card: {
    maxWidth: "460px",
    background: "white",
    padding: "24px",
    borderRadius: "14px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },

  subtitle: {
    color: "#555",
    marginTop: "-6px",
  },

  message: {
    padding: "12px",
    background: "#fff3cd",
    borderRadius: "8px",
    marginBottom: "14px",
  },

  input: {
    width: "100%",
    padding: "14px",
    marginBottom: "12px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },

  divider: {
    border: "none",
    borderTop: "1px solid #eee",
    margin: "18px 0",
  },

  note: {
    color: "#555",
    fontSize: "14px",
  },

  button: {
    width: "100%",
    padding: "15px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "bold",
  },
};

export default AccountSettings;